import { useEffect, useState } from "react";

import PropTypes from "prop-types";


import { apiClient, getErrorMessage } from "../../shared";
import { useSnackbar } from "../../ui";
import { PaymentMethodFormDialog } from "../payment-method-form-dialog";

import { Button } from "@mui/material";

export const EditPaymentMethodFormDialog = ({
  isOpen,
  onClose,
  paymentMethodId,
  onSubmitted,
}) => {
  const { showSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [defaultValues, setDefaultValues] = useState(null);

  useEffect(() => {
    if (!isOpen) return;

    const fetchProductCategory = async () => {
      setIsLoading(true);
      try {
        const {
          data: {
            data: { name, status },
          },
        } = await apiClient.get(`payment-methods/${paymentMethodId}`);
        setDefaultValues({
          name,
          status,
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchProductCategory();
  }, [isOpen, paymentMethodId]);

  const handleSubmit = async ({ name, status }) => {
    try {
      await apiClient.put(`payment-methods/${paymentMethodId}`, {
        name,
        status,
      });

      onSubmitted();
      onClose();
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal memperbarui metode pembayaran"));

      throw error;
    }
  };

  return (
    <PaymentMethodFormDialog
      isOpen={isOpen}
      onClose={onClose}
      dialogTitle="Ubah Metode Pembayaran"
      isLoading={isLoading}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      renderDialogActionsChildren={({ isLoading }) => (
        <Button loading={isLoading} variant="contained" type="submit">
          Simpan
        </Button>
      )}
    />
  );
};

EditPaymentMethodFormDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmitted: PropTypes.func.isRequired,
  paymentMethodId: PropTypes.string,
};
